<template>
	<!-- S'il s'agit d'une liste avec avec plusieurs sélections possibles -->
	 <div :class="{ 'invalid': field.State == false }">
		<multiselect :id="field.Name"
					:options="field.ListName ? listItems(field.ListName, field.TargetFilter, field.FilterValue, field.ExcludedItems) : field.ListItems"
					:disabled="ConsultMode === objectDisplayingModeEnum.Read || field.Disabled || field.ReadOnly"
					:required="field.Required"
					:close-on-select="true"
					:allow-empty="true"
					:searchable="false"
					:show-labels="false"
					:multiple="true"
					:max-height="150"
					track-by="Id"
					label="Label"
					placeholder=""
					class="mt-0 mb-0 ml-0 mr-3 pt-0 d-inline-block h-100"
					:style="ConsultMode === objectDisplayingModeEnum.Read ? 'background: transparent !important; background-color: transparent !important' : 'background: white !important; background-color: white !important'"
					v-model="selectedItems"
					@input="updateValue(field)">
					
					<!-- Modification icone d'ouverture de la liste déroulante -->
					<template #caret={toggle}>
						<span class="multiselect__select pr-0">
							<b-icon icon="chevron-down" font-scale="0.55" shift-h="7" style="stroke: black !important; stroke-width: 1.5px !important;"/>
						</span>
					</template>
		</multiselect>
	</div>
</template>

<script lang="ts">
	import { Vue, Component, Prop, Watch, PropSync } from "vue-property-decorator";
	import { Getter } from "vuex-class";
	import MultiSelectListField from "@/types/fields/MultiSelectListField";
	import ListItem from "@/types/fields/ListItem";
	import ObjectDisplayingModeEnum from "@/enums/ObjectDisplayingModeEnum";
	import Multiselect from 'vue-multiselect';
	import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";

	/** ⚠ Chargement d'options en asynchrone (ou pas) pour éviter de prolonger le chargement initial de la fiche objet si un nom de liste a été fourni */
	@Component({
		components: {
			Multiselect
		}
	})
	export default class MultiSelectList extends Vue {
		/** Pour pouvoir utiliser les enums dans la section template */
		private fieldTypeEnum = FieldTypeEnum;
		private objectDisplayingModeEnum = ObjectDisplayingModeEnum;

		/** Indique si les champs du formulaire sont éditables ou en mode consultation */
		@Prop()
		public ConsultMode!: ObjectDisplayingModeEnum;

		/** Champ de type SelectListField à traiter */
		@PropSync('Field')
		public field!: MultiSelectListField;

		/** Watch permettant de recharger complétement les données du multiselect en cas de nouvel objet 'field' */
		@Watch('field', { deep: false })
  		private onFieldChange(newVal: MultiSelectListField, oldVal: MultiSelectListField) {
			console.debug("MultiSelectListField - onFieldChange()");
			if (newVal){
				this.selectedItems = this.listItems(newVal.ListName, newVal.TargetFilter, newVal.FilterValue, newVal.ExcludedItems).filter(x => (newVal.Value as number[]).includes(x.Id));				
				this.updateValue(newVal);
			}
		}

		@Watch('field.FilterValue', { immediate: true })
		private async fieldUpdated() {
			console.debug("MultiSelectListField - Field updated : ListName : " + this.field.ListName + " - TargetFilter : " + this.field.TargetFilter + " - FilterValue :" + this.field.FilterValue)
			if (this.field.FilterValue != 0)
                await this.$store.dispatch("LoadListItems", [{ listName: this.field.ListName, targetFilter: this.field.TargetFilter, filterValue: this.field.FilterValue }]);
		}

		/** Mise à jour Value car le composant MultiSelect stocke l'objet ListItem complet dans son v-model et non seulement l'Id */
		@Watch('selectedItems')
		private updateFieldValue() {
			console.debug("MultiSelectListField - SelectListField - updateFieldValue()")
			if (this.selectedItems) {
				this.field.Value = this.selectedItems.map(item => { return item.Id });
				console.debug("MultiSelectListField - SelectListField - updateFieldValue() - this.Field.Value.length : ", (this.field.Value as number[]).length);
			}

			console.debug("MultiSelectListField - SelectListField - selectedItems a changé !!");
		}

		/** Items de SelectList obtenu en async */
		@Getter('GetListItems')
		private listItems!: (listName: string, targetFilter: string, filterValue: number, excludedItems: number[]) => ListItem[];

		/** Liste des items sélectionnés dans la liste */
		private selectedItems: ListItem[] = [];

		private find(list: any[], attribute: string, value: any): any {
			let id = list.findIndex(x => x[attribute] == value);
			if (id > -1)
				return list[id];
			else
				return;
		}

		/** Mise à jour de la valeur d'un field */
		private updateValue(element: MultiSelectListField) {
            let item: ListItem = this.find(this.listItems(this.field.ListName, this.field.TargetFilter, this.field.FilterValue, this.field.ExcludedItems), "Id", element.Value);
            if (item)
                element.Extras = item.Extras;
            this.$store.dispatch("ObjectStore/UpdateValue", { newElement: element });
        }

        async mounted() {
            if (this.field.ListName){
                await this.$store.dispatch("LoadListItems", [{ listName: this.field.ListName, targetFilter: this.field.TargetFilter, filterValue: this.field.FilterValue }]).then(() => {
					this.selectedItems = this.listItems(this.field.ListName, this.field.TargetFilter, this.field.FilterValue, this.field.ExcludedItems).filter(x => (this.field.Value as number[]).includes(x.Id));
				});
			}
        }
	}

</script>

<style scoped>
	/** @todo: Sans doute redondant avec contenu de Fields.vue ==> A REFACTORISER !!!! */
	.form-row {
		padding-bottom: 0%;
		margin-bottom: 0.2rem;
	}

	/** Aligne les labels au milieu verticalement */
	div::v-deep .col-form-label {
		vertical-align: middle !important;
	}

	:deep(input:disabled, select:disabled, .multiselect--disabled > *) {
		border: 0 !important;
		box-shadow: none !important;
		background: transparent !important;
		background-color: transparent !important;
		/* color: darkgray; */
		cursor: default !important;
	}

	select[disabled] {
		-webkit-appearance: none;
		-moz-appearance: none;
		text-indent: 0.01px;
		text-overflow: '';
	}

	.input-group-text {
		border: 0 !important;
		box-shadow: none !important;
		background-color: transparent !important;
		cursor: default !important;
	}
</style>